// chakra imports
import {
	Button,
	Flex,
	Input,
	Radio,
	RadioGroup,
	SimpleGrid,
	Text,
	Textarea,
} from "@chakra-ui/react";
import React from "react";

export default function Form() {
	return (
		<>
			<form
				action='https://forms.zohopublic.eu/horizonui/form/HorizonUICustomDevelopment/formperma/S2ZHnQVHjEFB-WMgYwmMyzIU_0wg3xPaSnFgVoKeKEU/htmlRecords/submit'
				name='form'
				id='form'
				method='POST'
				style={{ width: "100%" }}
				accept-charset='UTF-8'
				enctype='multipart/form-data'>
				<input type='hidden' name='zf_referrer_name' value='' />
				<input type='hidden' name='zf_redirect_url' value='' />
				<input type='hidden' name='zc_gad' value='' />
				<p></p>
				<Flex flexDirection='column' gap='40px'>
					<Flex
						w='100%'
						flexDirection={{ base: "column", md: "row" }}
						gap='30px'>
						<Flex flexDirection='column' w='100%'>
							<Text mb='6px' fontWeight='700' letterSpacing='0px'>
								First Name:*
							</Text>
							<Input
								isRequired
								type='text'
								w='100%'
								variant='main'
								name='Name_First'
								fieldType='7'
								placeholder='Enter&#x20;your&#x20;first&#x20;name'
							/>
						</Flex>
						<Flex flexDirection='column' w='100%'>
							<Text mb='6px' fontWeight='700' letterSpacing='0px'>
								Last Name:*
							</Text>
							<Input
								isRequired
								type='text'
								w='100%'
								variant='main'
								name='Name_Last'
								fieldType='7'
								placeholder='Enter&#x20;your&#x20;last&#x20;name'
							/>
						</Flex>
					</Flex>
					<Flex flexDirection='column' w='100%'>
						<Text mb='6px' fontWeight='700' letterSpacing='0px'>
							Email Address:*
						</Text>
						<Input
							isRequired
							type='text'
							w='100%'
							variant='main'
							name='Email'
							fieldType='9'
							placeholder='Enter&#x20;your&#x20;email&#x20;address'
						/>
					</Flex>
					<Flex flexDirection='column' w='100%'>
						<Text mb='6px' fontWeight='700' letterSpacing='0px'>
							Tell us a bit about your project:*
						</Text>
						<Textarea
							bg='white'
							border='1px solid'
							color='#09090B'
							borderColor='#E4E4E7'
							borderRadius='8px'
							fontWeight='600'
							minH='242px'
							fontSize='md'
							p='20px'
							_placeholder={{ color: "#71717A", fontWeight: "500" }}
							_hover={{ borderColor: "#E4E4E7" }}
							_active={{ borderColor: "#E4E4E7" }}
							_focus={{ borderColor: "#E4E4E7" }}
							name='MultiLine'
							maxlength='65535'
							placeholder='Type&#x20;your&#x20;message&#x20;here...'></Textarea>
					</Flex>
					<Flex flexDirection='column' w='100%'>
						<Text mb='6px' fontWeight='700' letterSpacing='0px'>
							I need for my project:*
						</Text>
						<RadioGroup
							display='flex'
							gap='30px'
							flexDirection={{ base: "column", md: "row" }}>
							<Radio
								variant='primary'
								type='radio'
								id='Radio_1'
								justifyContent={{ base: "start", md: "center" }}
								name='Radio'
								value='Option&#x20;A&#x3a;&#x20;One&#x20;or&#x20;more&#x20;developers'>
								<Text
									color='#71717A'
									fontWeight='500'
									for='Radio_1'
									letterSpacing='0px'>
									<Text color='#09090B' me='2px' fontWeight='700' as='span'>
										Option A:
									</Text>
									One or more developers
								</Text>
							</Radio>
							<Radio
								variant='primary'
								type='radio'
								id='Radio_2'
								justifyContent={{ base: "start", md: "center" }}
								name='Radio'
								value='Option&#x20;B&#x3a;&#x20;An&#x20;entire&#x20;team'>
								<Text
									color='#71717A'
									fontWeight='500'
									for='Radio_2'
									letterSpacing='0px'>
									<Text color='#09090B' me='2px' fontWeight='700' as='span'>
										Option B:
									</Text>
									An entire team
								</Text>
							</Radio>
						</RadioGroup>
					</Flex>
					<Flex flexDirection='column' w='100%'>
						<Text mb='6px' fontWeight='700' letterSpacing='0px'>
							Approximate budget:*
						</Text>
						<RadioGroup>
							<SimpleGrid columns={{ base: "1", md: "2" }} gap='30px'>
								<Radio
									variant='main'
									type='radio'
									id='Radio1_1'
									name='Radio1'
									value='&#x24;2.500&#x20;-&#x20;&#x24;15.000&#x20;Good&#x20;for&#x20;small&#x20;projects'>
									<Text
										color='#71717A'
										fontWeight='500'
										for='Radio1_1'
										letterSpacing='0px'>
										<Text color='#09090B' fontWeight='700'>
											$2.500 - $15.000
										</Text>
										Good for small projects
									</Text>
								</Radio>
								<Radio
									variant='main'
									type='radio'
									id='Radio1_2'
									name='Radio1'
									value='&#x24;15.000&#x20;-&#x20;&#x24;50.000&#x20;Good&#x20;for&#x20;bigger&#x20;projects'>
									<Text
										color='#71717A'
										fontWeight='500'
										for='Radio1_2'
										letterSpacing='0px'>
										<Text color='#09090B' fontWeight='700'>
											$15.000 - $50.000
										</Text>
										Good for bigger projects
									</Text>
								</Radio>
								<Radio
									type='radio'
									id='Radio1_3'
									name='Radio1'
									value='&#x24;50.000&#x20;-&#x20;&#x24;100.000&#x20;Good&#x20;for&#x20;large&#x20;scale&#x20;projects'>
									<Text
										color='#71717A'
										fontWeight='500'
										for='Radio1_3'
										letterSpacing='0px'>
										<Text color='#09090B' fontWeight='700'>
											$50.000 - $100.000
										</Text>
										Good for large scale projects
									</Text>
								</Radio>
								<Radio
									type='radio'
									id='Radio1_4'
									name='Radio1'
									value='&#x24;100.000&#x2b;&#x20;Good&#x20;for&#x20;major&#x20;long&#x20;term&#x20;projects'>
									<Text
										color='#71717A'
										fontWeight='500'
										for='Radio1_4'
										letterSpacing='0px'>
										<Text color='#09090B' fontWeight='700'>
											$100.000+
										</Text>
										Good for major long term projects
									</Text>
								</Radio>
							</SimpleGrid>
						</RadioGroup>
					</Flex>
					<Button
						type='submit'
						h='70px'
						width='100%'
						borderRadius='999px'
						variant='primaryGradient'>
						Submit Message
					</Button>
				</Flex>
			</form>
		</>
	);
}
